import OnlineWaiverSettlement from "./waiver/components/onlineWaiverSettlement/onlineWaiverSettlement";
// import ReadyReckoner from "./readyRecoknor/readyRecoknor";
// import Analytics from "./analytics/components/analytics/analytics";
import Reconciliation from "./autoRecon/components/reconciliation/reconciliation";
// import LiveTracking from "./trips/components/liveTracking/liveTracking";
// import TripHistory from "./trips/components/history/tripHistory";
import DynamicReports from "./reports/components/dynamicReports/dynamicReports";
// import BatchReports from "./reports/components/batchReports/batchReports";
import VisitAssignmentsPlotting from "./trips/components/visitAssignmentsPlotting/visitAssignmentsPlotting";
import React, { Suspense } from "react";
import CustomLoader from "../components/loader";

const ReadyReckoner = React.lazy(() => import("./readyRecoknor/readyRecoknor"));
const LiveTracking = React.lazy(() => import("./trips/components/liveTracking/liveTracking"));
const TripHistory = React.lazy(() => import("./trips/components/history/tripHistory"));

type MapType = Map<string, any>;

const userDetails = JSON.parse(localStorage?.getItem("user") || "{}");
const { username, userType } = userDetails;

export default function getCustomLandingPageMap(): MapType {
    // Create a new Map
    const customLandingPageMap: MapType = new Map();

    customLandingPageMap.set("onlineWaiver", <OnlineWaiverSettlement loanNo={userType === 'External' ? username : ""} />);

    customLandingPageMap.set("readyReckoner", <Suspense fallback={<div className="text-center py-5"> <CustomLoader tip={"Loading..."} size="lg"></CustomLoader> </div>}> <ReadyReckoner /> </Suspense>);

    customLandingPageMap.set("reconciliation", <Reconciliation />);

    customLandingPageMap.set("geotaggingLiveTracking", <Suspense fallback={<div className="text-center py-5"> <CustomLoader tip={"Loading..."} size="lg"></CustomLoader> </div>}> <LiveTracking /> </Suspense>);
    customLandingPageMap.set("geotaggingHistory", <Suspense fallback={<div className="text-center py-5"> <CustomLoader tip={"Loading..."} size="lg"></CustomLoader> </div>}><TripHistory /></Suspense>);
    customLandingPageMap.set("geoLocationPlotting", <VisitAssignmentsPlotting />);

    // customLandingPageMap.set("analytics", <Analytics />);

    customLandingPageMap.set("dynamicReports", <DynamicReports />);
    // customLandingPageMap.set("batchReports", <BatchReports />);

    return customLandingPageMap;
}